import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  GameDubaiMultiplayer,
  GameDubaiGameChat,
  GameDubaiAI,
  GameDubaiPurchase,
  GameDubaiCrossPlatform,
  GameDubaiRobust,
  GameDubaiGamefication,
} from "../../../../app-constants-updated";
import BgImg from "../../../images/locationgcc/game/kiiler-graphics.webp";

const Hireexpertweb = () => {
  return (
    <div
      className="hire_expert game-dubai-features tekrevol_dark_bg p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>
              Killer Graphics, Low <span>Latency & Amazing</span> Results
            </h2>
            <p>
              With all these features and functions that make the gameplay
              experience second to none, there is one more thing TekRevol
              doesn’t compromise on; excellence. The ever-competitive gaming
              industry has shortened the attention span, and to capture the
              attention in that short amount of time, TekRevol can help you
              develop flawless games.
            </p>
            <p>
              TekRevol is always aware of the latest industry trends, and we
              follow them regardless of the platform you have chosen to get your
              game built. Whether iOS or Android, we follow the trends and
              maintain the quality standards – from in-game characters to depth
              in the surroundings to the seamless movements, we take care of it
              all.
            </p>
            <h6>
              Top Features of Our Game App Development That Take Your Game to
              the next level:
            </h6>
          </Col>
        </Row>

        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="m-auto">
            <div className="tech_stackgcc">
              <div className="tech_stackbox">
                {GameDubaiMultiplayer}
                <div className="tech_stacktitle">
                  <h6>Dynamic Multiplayer Capabilities</h6>
                </div>
              </div>
              <div className="tech_stackbox">
                {GameDubaiGameChat}
                <div className="tech_stacktitle">
                  <h6>Real-time In-Game Chat</h6>
                </div>
              </div>
              <div className="tech_stackbox">
                {GameDubaiAI}
                <div className="tech_stacktitle">
                  <h6>Advanced AI Integration</h6>
                </div>
              </div>
              <div className="tech_stackbox">
                {GameDubaiPurchase}
                <div className="tech_stacktitle">
                  <h6>In-App Purchases and Monetization Strategies</h6>
                </div>
              </div>
              <div className="tech_stackbox">
                {GameDubaiCrossPlatform}
                <div className="tech_stacktitle">
                  <h6>Cross-Platform Compatibility</h6>
                </div>
              </div>
              <div className="tech_stackbox">
                {GameDubaiRobust}
                <div className="tech_stacktitle">
                  <h6>Robust Security Measures</h6>
                </div>
              </div>
              <div className="tech_stackbox">
                {GameDubaiGamefication}
                <div className="tech_stacktitle">
                  <h6>Gamification Elements for User Engagement</h6>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Hireexpertweb;
